<script setup lang="ts">
const page = usePage().value;
</script>

<template>
  <section v-if="page?.featurePhotos.length" id="featurePhotos">
    <AppPhotoCarousel :slideshow="page?.featurePhotos" />
  </section>
</template>
